"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && (module.exports = {
    INTERNAL_SLOT_NAME: null,
    NOT_FOUND_ROUTE_NAME: null,
    SITEMAP_ROUTE_NAME: null
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get INTERNAL_SLOT_NAME () {
        return INTERNAL_SLOT_NAME;
    },
    get NOT_FOUND_ROUTE_NAME () {
        return NOT_FOUND_ROUTE_NAME;
    },
    get SITEMAP_ROUTE_NAME () {
        return SITEMAP_ROUTE_NAME;
    }
});
const INTERNAL_SLOT_NAME = '__root';
const NOT_FOUND_ROUTE_NAME = '+not-found';
const SITEMAP_ROUTE_NAME = '_sitemap';

//# sourceMappingURL=constants.js.map
